var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 800,
  height: 800,
  viewBox: "0 0 512 512",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "red",
  fillRule: "evenodd",
  d: "M256 42.667c117.803 0 213.333 95.53 213.333 213.333S373.803 469.333 256 469.333 42.667 373.803 42.667 256 138.197 42.667 256 42.667m0 42.666C161.899 85.333 85.333 161.9 85.333 256S161.9 426.667 256 426.667 426.667 350.1 426.667 256 350.1 85.333 256 85.333m48.917 91.584 30.166 30.166L286.165 256l48.918 48.917-30.166 30.166L256 286.165l-48.917 48.918-30.166-30.166L225.835 256l-48.918-48.917 30.166-30.166L256 225.835z"
})));
export { SvgError as ReactComponent };
export default __webpack_public_path__ + "assets/images/error.svg";